import React from 'react';
import {connect} from 'react-redux';
import {filterObjectByParams, sortArrayOfObjects} from 'helpers/common-helper';
import {PlayersList as BasePlayersList} from 'components/organisms/used-players-list/components/players-list';
import PlayerExposure from 'components/molecules/player-exposure';
import PlayerPoints from 'components/molecules/player-points';
import PlayerExclusionSwitcher from 'components/molecules/player-exclusion/player-exclusion-switcher';
import FilterLineupsByPlayer from 'components/molecules/filter-lineups-by-player';

class PlayersListComponent extends BasePlayersList {
    getPlayers() {
        const filteredPlayers = this.getFilteredUsedPlayers();

        const searchParams = {
            ...this.getSearchRuleByPosition(),
        };

        let players = filterObjectByParams(filteredPlayers, searchParams, true);

        return sortArrayOfObjects(players, 'usedLineupsCount', 'desc');
    }

    render() {
        const players = this.getPlayers();
        const renderKey = this.getRenderKey();

        const items = [];
        if (!isEmpty(players)) {
            Object.values(players).map((player, index) => {
                const className = index % 2 === 0 ? 'even' : '';

                items.push(
                    <tr key={`${renderKey}${index}`} className={className}>
                        <td className="check">
                            <PlayerExclusionSwitcher playerId={player.getId()} />
                        </td>
                        <td>
                            <FilterLineupsByPlayer player={player} />
                        </td>
                        <td className="name">{player.name}</td>
                        <td className="td-team">{player.opponent}</td>
                        <td>
                            {this.wrapContentInTooltip(
                                <PlayerPoints
                                    className="form-control xs-table-input"
                                    playerId={player.getId()}
                                    propName={'userPoints'}
                                />,
                                `Default Score: ${player.adminPoints}`,
                            )}
                        </td>
                        {this.getPlayerExposureView(player)}
                        <td>
                            <span>{player.projOwn.getValue()}</span>
                        </td>
                        <td className="td-narrow">
                            <div className="percent-in">
                                <PlayerExposure
                                    className="form-control small-table-input"
                                    playerId={player.getId()}
                                    propName={'exposureMin'}
                                />
                                <span className="percent">%</span>
                            </div>
                        </td>
                        <td className="td-narrow">
                            <div className="percent-in">
                                <PlayerExposure
                                    className="form-control small-table-input"
                                    playerId={player.getId()}
                                    propName={'exposureMax'}
                                />
                                <span className="percent">%</span>
                            </div>
                        </td>
                    </tr>,
                );
            });
        } else {
            items.push(this.getPlayersNotFoundView({colSpan: 8}));
        }

        return (
            <div className="players-used-table table-holder">
                <div className="table-scroll">
                    <table className="table">
                        <thead>
                            <tr>
                                <th></th>
                                <th></th>
                                <th>Name</th>
                                <th className="td-team">Opp</th>
                                <th>FPts</th>
                                <th>Exp%</th>
                                <th>
                                    Proj
                                    <br />
                                    Own%
                                </th>
                                <th>
                                    Exp.
                                    <br />
                                    min
                                </th>
                                <th>
                                    Exp.
                                    <br />
                                    max
                                </th>
                            </tr>
                        </thead>
                        <tbody>{items}</tbody>
                    </table>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        usedPlayers,
        filterLineupsByPlayer,
        lineupsData: {lineups},
    } = state;
    return {
        usedPlayers: usedPlayers.players,
        filters: usedPlayers.filters,
        filterLineupsByPlayer,
        lineups,
    };
}

let PlayersList = connect(mapStatesToProps)(PlayersListComponent);

export {PlayersList};
